import axiosInstance from '../../../api/axiosConfig';

const oneDriveService = {
  initiateAuth: async () => {
    const response = await axiosInstance.post('/proceedings/onedrive/auth');
    return response.data;
  },

  // Resolve the driveId for a SharePoint personal site (needed for shared/external drives)
  resolveSharePointUrl: async (accessToken, hostname, sitePath) => {
    const response = await axiosInstance.get('/proceedings/onedrive/resolve-sp-url', {
      params: { accessToken, hostname, sitePath },
    });
    return response.data;
  },

  listFolders: async (accessToken, folderPath = '/', driveId = null) => {
    const response = await axiosInstance.get('/proceedings/onedrive/folders', {
      params: { accessToken, folderPath, ...(driveId && { driveId }) },
    });
    return response.data;
  },

  getFolderContents: async (accessToken, folderPath = '/', recursive = false, driveId = null) => {
    const response = await axiosInstance.get('/proceedings/onedrive/contents', {
      params: { accessToken, folderPath, recursive, ...(driveId && { driveId }) },
    });
    return response.data;
  },

  countFiles: async (accessToken, folderPath = '/', recursive = true, driveId = null) => {
    const response = await axiosInstance.get('/proceedings/onedrive/count-files', {
      params: { accessToken, folderPath, recursive, ...(driveId && { driveId }) },
    });
    return response.data;
  },

  refreshToken: async (refreshToken) => {
    const response = await axiosInstance.post('/proceedings/onedrive/refresh-token', {
      refreshToken,
    });
    return response.data;
  },

  startNewProceedingsImport: async (importData) => {
    const response = await axiosInstance.post('/proceedings/bulk-import/new-proceedings', importData);
    return response.data;
  },

  startExistingProceedingsImport: async (importData) => {
    const response = await axiosInstance.post('/proceedings/bulk-import/existing-proceedings', importData);
    return response.data;
  },

  getJobStatus: async (jobId) => {
    const response = await axiosInstance.get(`/proceedings/bulk-import/jobs/${jobId}/status`);
    return response.data;
  },

  getActiveJobs: async () => {
    const response = await axiosInstance.get('/proceedings/bulk-import/jobs/active');
    return response.data;
  },

  getJobHistory: async (limit = 20) => {
    const response = await axiosInstance.get('/proceedings/bulk-import/jobs/history', {
      params: { limit },
    });
    return response.data;
  },

  resumeJob: async (jobId) => {
    const response = await axiosInstance.post(`/proceedings/bulk-import/jobs/${jobId}/resume`);
    return response.data;
  },

  cancelJob: async (jobId) => {
    const response = await axiosInstance.post(`/proceedings/bulk-import/jobs/${jobId}/cancel`);
    return response.data;
  },

  downloadReport: async (jobId) => {
    const response = await axiosInstance.get(`/proceedings/bulk-import/jobs/${jobId}/report`, {
      responseType: 'blob',
    });
    return response;
  },
};

export default oneDriveService;
